<template>
  <div class="jipvio-dashboard">
    <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
      <!-- <notifications></notifications> -->
      <side-bar>
        <template slot="links">
          <!-- <user-menu></user-menu> -->

          <sidebar-item v-for="ct in contents" :link="ct" :key="ct.index">
            <div v-if="ct.uType == 'ADM' && ct.name == '매물관리'">
              <sidebar-item
                v-for="cd in contents.pptMgmt.children"
                :link="cd"
                :key="cd.index"
              >
              </sidebar-item>
            </div>

            <div v-if="ct.uType == 'ADM' && ct.name == '회원관리'">
              <sidebar-item
                v-for="cd in contents.memMgmt.children"
                :link="cd"
                :key="cd.index"
              >
              </sidebar-item>
            </div>

            <div v-if="ct.uType == 'ADM' && ct.name == '게시판관리'">
              <sidebar-item
                v-for="cd in contents.brdMgmt.children"
                :link="cd"
                :key="cd.index"
              >
              </sidebar-item>
            </div>
          </sidebar-item>

          <!---------------------------------------------------------->
          <!-- <sidebar-item
            :link="{
              name: 'mypage test',
              icon: 'now-ui-icons design_app',
              path: '/mypage/test'
            }"
          >s
          </sidebar-item>
          <sidebar-item
            :link="{
              name: '매물등록',
              icon: 'now-ui-icons design_app',
              path: '/mypage/test6'
            }"
          >
          </sidebar-item>
          <sidebar-item
            :link="{
              name: '매물관리',
              icon: 'now-ui-icons design_app',
              path: '/mypage/test2'
            }"
          >
          </sidebar-item>
          <sidebar-item
            :link="{
              name: '계약관리',
              icon: 'now-ui-icons design_app',
              path: '/mypage/test3'
            }"
          >
          </sidebar-item>
          <sidebar-item
            :link="{
              name: '문의내역',
              icon: 'now-ui-icons design_app',
              path: '/mypage/test4'
            }"
          >
          </sidebar-item>
          <sidebar-item
            :link="{
              name: '찜한매물',
              icon: 'now-ui-icons design_app',
              path: '/mypage/test5'
            }"
          >
          </sidebar-item> -->

          <!-- ----------------------------------------- -->
          <!--           
          <sidebar-item
            :link="{ name: 'Pages', icon: 'now-ui-icons design_image' }"
          >
            <sidebar-item
              :link="{ name: 'Pricing', path: '/pricing' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Timeline', path: '/pages/timeline' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Login', path: '/login' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Register', path: '/register' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Lock Screen', path: '/lock' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'User Profile', path: '/pages/user' }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item
            :link="{ name: 'Components', icon: 'now-ui-icons education_atom' }"
          >
            <sidebar-item
              :link="{ name: 'Buttons', path: '/components/buttons' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Grid System', path: '/components/grid-system' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Panels', path: '/components/panels' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Sweet Alert', path: '/components/sweet-alert' }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Notifications',
                path: '/components/notifications'
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Icons', path: '/components/icons' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Typography', path: '/components/typography' }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item
            :link="{ name: 'Forms', icon: 'now-ui-icons files_single-copy-04' }"
          >
            <sidebar-item
              :link="{ name: 'Regular Forms', path: '/forms/regular' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Extended Forms', path: '/forms/extended' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Validation Forms', path: '/forms/validation' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Wizard', path: '/forms/wizard' }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item
            :link="{
              name: 'Tables',
              icon: 'now-ui-icons design_bullet-list-67'
            }"
          >
            <sidebar-item
              :link="{ name: 'Regular Tables', path: '/table-list/regular' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Extended Tables', path: '/table-list/extended' }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Paginated Tables',
                path: '/table-list/paginated'
              }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item
            :link="{ name: 'Maps', icon: 'now-ui-icons location_pin' }"
          >
            <sidebar-item
              :link="{ name: 'Google Maps', path: '/maps/google' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Full Screen Maps', path: '/maps/full-screen' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Vector Maps', path: '/maps/vector-map' }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item
            :link="{
              name: 'Widgets',
              icon: 'now-ui-icons objects_diamond',
              path: '/widgets'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Charts',
              icon: 'now-ui-icons business_chart-pie-36',
              path: '/charts'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Calendar',
              icon: 'now-ui-icons media-1_album',
              path: '/calendar'
            }"
          ></sidebar-item> -->
        </template>
      </side-bar>
      <div class="main-panel">
        <router-view name="mypage"></router-view>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
// import PerfectScrollbar from "perfect-scrollbar";
// import "perfect-scrollbar/css/perfect-scrollbar.css";

import { createNamespacedHelpers, mapGetters } from "vuex";
const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

// function initScrollbar(className) {
//   if (hasElement(className)) {
//     new PerfectScrollbar(`.${className}`);
//   } else {
//     // try to init it later in case this component is loaded async
//     setTimeout(() => {
//       initScrollbar(className);
//     }, 100);
//   }
// }

import TopNavbar from "./TopNavbar.vue";
import MainFooter from "./MainFooter.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import SidebarItem from "../components/SidebarPlugin/SidebarItem.vue";

export default {
  components: {
    TopNavbar,
    MainFooter,
    UserMenu,
    ZoomCenterTransition,
    SidebarItem
  },

  data() {
    return {
      contents: {}
    };
  },

  created() {
    console.log(this.sessionUserInfo.type);
    if (this.sessionUserInfo.type == "LE") {
      this.contents = {
        normaldashbrd: {
          name: "Dashbord",
          icon: "fas fa-chart-pie",
          path: "/mypage/dash",
          uType: "LEE"
        },
        likePpt: {
          name: "찜한매물",
          icon: "now-ui-icons ui-2_favourite-28",
          path: "/mypage/like",
          uType: "LEE"
        },
        qstnList: {
          name: "문의내역",
          icon: "now-ui-icons design_bullet-list-67",
          path: "/mypage/qst/list",
          uType: "LEE"
        },
        contMgmt: {
          name: "계약관리",
          icon: "jipvio-ui-icons-draw_up",
          path: "/mypage/cont/mgmt",
          uType: "LEE"
        }
      };
    } else if (this.sessionUserInfo.type == "AG") {
      this.contents = {
        pptdashbrd: {
          name: "Dashbord",
          icon: "fas fa-chart-pie",
          path: "/mypage/dash",
          uType: "LER"
        },

        pptMgmt: {
          name: "매물관리",
          icon: "now-ui-icons design_bullet-list-67",
          path: "/mypage/ppt/mgmt",
          uType: "LER"
        },
        contMgmt: {
          name: "계약관리",
          icon: "jipvio-ui-icons-draw_up",
          path: "/mypage/cont/mgmt",
          uType: "LER"
        },
        qstnList: {
          name: "문의내역",
          icon: "jipvio-ui-icons-document_sheet",
          path: "/mypage/qst/list",
          uType: "LER"
        }
      };
    } else if (this.sessionUserInfo.type == "LO") {
      this.contents = {
        pptdashbrd: {
          name: "Dashbord",
          icon: "fas fa-chart-pie",
          path: "/mypage/dash",
          uType: "LER"
        },

        pptMgmt: {
          name: "매물관리",
          icon: "now-ui-icons design_bullet-list-67",
          path: "/mypage/ppt/mgmt",
          uType: "LER"
        },
        contMgmt: {
          name: "계약관리",
          icon: "jipvio-ui-icons-draw_up",
          path: "/mypage/cont/mgmt",
          uType: "LER"
        },
        qstnList: {
          name: "문의내역",
          icon: "jipvio-ui-icons-document_sheet",
          path: "/mypage/qst/list",
          uType: "LER"
        }
      };
    } else if (this.sessionUserInfo.type == "AM") {
      this.contents = {
        pptdashbrd: {
          name: "Dashbord",
          icon: "fas fa-chart-pie",
          path: "/mypage/dash",
          uType: "ADM"
        },
        pptMgmt: {
          name: "매물관리",
          icon: "jipvio-ui-icons-document_plus",
          uType: "ADM",
          children: [
            {
              name: "임대인",
              path: "/mypage/admin/ppt/ler"
            },
            {
              name: "공인중개사",
              path: "/mypage/admin/ppt/agt"
            }
          ]
        },
        memMgmt: {
          name: "회원관리",
          icon: "now-ui-icons design_bullet-list-67",
          uType: "ADM",
          children: [
            {
              name: "임대인",
              path: "/mypage/admin/mem/ler"
            },
            {
              name: "공인중개사",
              path: "/mypage/admin/mem/agt"
            },
            {
              name: "임차인",
              path: "/mypage/admin/mem/lee"
            }
          ]
        },
        brdMgmt: {
          name: "게시판관리",
          icon: "jipvio-ui-icons-draw_up",
          uType: "ADM",
          children: [
            {
              name: "공지사항",
              path: "/mypage/admin/board/noti"
            },
            {
              name: "문의사항",
              path: "/mypage/admin/board/qst"
            }
          ]
        }
      };
    }
  },

  computed: {
    ...sessionMapGetters({
      sessionUserInfo: "getUserInfo"
    })
  },

  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      // initScrollbar("sidebar");
      // initScrollbar("sidebar-wrapper");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
